const termsContent: string[] = [
    `Pulseonship 이용약관<br /><br />
제1조 (목적)<br /><br />
본 서비스 약관은 회원이 주식회사 디인사이트(이하 "회사")에서 제공하는 Pulseonship 및 제반 서비스(이하 “서비스”라 합니다)를 이용함에 있어 회원과 회사간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.<br /><br />

제2조 (약관의 효력 및 변경)<br /><br />
① 본 약관은 서비스를 이용하고자 하는 모든 회원에 대하여 그 효력을 발생합니다.<br />

② 본 약관의 내용은 서비스 화면에 게시하거나 기타의 방법으로 회원에게 공시하고, 이에 동의한 회원이 서비스에 가입함으로써 효력이 발생합니다.<br />

③ 회사는 필요하다고 인정되는 경우 본 약관을 변경할 수 있으며, 회사가 약관을 변경할 경우에는 적용일자 및 변경사유를 명시하여 제2항과 같은 방법으로 그 적용일자 15일 전부터 공지하며, 회원에게 불리하거나 중대한 약관의 변경인 경우에는 그 적용일자 30일 전부터 공지하며, E-mail, SMS, App Push 등으로 회원에게 개별 통지합니다. 단, 회원의 연락처 미기재, 변경 후 미수정 등으로 인하여 개별 통지가 어려운 경우에 한하여 본 항의 공지를 함으로써 개별 통지 한 것으로 간주합니다.<br />

④ 회사가 제3항에 따라 변경 약관을 공지 또는 통지하면서, 회원에게 약관 변경 적용일까지 거부의사를 표시하지 아니할 경우, 약관의 변경에 동의한 것으로 간주한다는 내용을 공지 또는 통지하였음에도 회원이 명시적으로 약관 변경에 대한 거부의사를 표시하지 아니하면, 회원이 변경 약관에 동의한 것으로 간주합니다. 회원은 변경된 약관 사항에 동의하지 않으면 서비스 이용을 중단하고 이용 계약을 해지할 권리가 있습니다.<br /><br />

제3조 (약관 외 준칙)<br /><br />
본 약관에 명시되지 않은 사항에 대해서는 정보통신망 이용촉진 및 정보보호에 관한 법률(이하 “정보통신망법”이라 합니다), 위치정보의 보호 및 이용 등에 관한 법률(이하 “위치정보법”이라 합니다), 개인정보 보호법, 전기통신기본법, 전기통신사업법 등 관계법령 및 회사가 정한 서비스의 세부이용지침 등의 규정에 의합니다.<br /><br />

제4조 (용어의 정의)<br /><br />
① 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.<br />

1. “서비스” 란 이용 고객 또는 회원이 PC, 이동전화, 휴대용 단말기, 차량단말기 등 각종 유무선 기기 또는 프로그램을 통하여 이용할 수 있도록 회사가 Pulseonship이라는 브랜드로 제공하는 최적경로 및 배차 서비스, 기능별 API 서비스, 내비게이션(교통정보 등 포함) 서비스를 가리킴. 이하 동일) 및 관련 제반 서비스를 말합니다.<br />

2. “회원”이란 서비스 웹사이트 또는 서비스 전용 어플리케이션을 통하여 본 약관에 동의하고, 서비스 이용을 신청하여, 회사로부터 서비스 이용에 대한 자격을 부여 받은 고객을 말합니다.<br />

3. “사이트”란 서비스를 제공하는 유무선 홈페이지를 말합니다.<br />

4. “ID”란 회원 식별과 회원의 서비스 이용을 위하여 회원이 선정하고 회사가 승인하는 영문자와 숫자의 조합을 말합니다.<br />

5. “PASSWORD”란 회원의 정보 보호를 위해 회원 자신이 설정한 문자와 숫자의 조합을 말합니다.<br />

6. “운영자”란 서비스의 전반적인 관리와 원활한 운영을 위하여 회사가 선정한 자를 말합니다.<br />

② 본 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계 법령 및 서비스별 안내에서 정하는 바에 의하며, 그러한 정의가 없는 경우 일반적 상관습에 따릅니다.<br /><br />

제5조 (이용 신청)<br /><br />
① 서비스에 가입을 하여 이용하고자 하는 자는 본 약관에 동의하여 가입절차를 진행하여 서비스를 이용할 수 있습니다.<br />

② 서비스에 가입을 하여 이용하고자 하는 자는 회사에서 제공된 회원가입 신청양식에 따라 필요사항을 기재하여야 합니다. 회원가입 시 기재항목은 필수 기재 항목과 선택 기재 항목으로 구분되어 있으며 필수 기재 항목의 경우 반드시 입력을 해야 합니다.<br />

③ 회사는 서비스에 가입을 하여 이용하고자 하는 자에게 “SMS 인증” 기타 본인을 확인할 수 있는 인증절차를 요구할 수 있습니다. 이 경우 서비스에 가입을 하여 이용하고자 하는 자는 해당 인증을 수행하는 등 가입절차를 완료하여야 합니다.<br />

④ 제3항에 따른 인증의 정확성을 위하여 서비스에 가입을 하여 이용하고자 하는 자는 본인 명의의 이동전화를 이용하여 인증절차를 수행하여야 합니다. 본인의 관리 소홀로 타인이 본인 명의의 인증절차를 수행하거나, 본인이 타인의 명의를 도용하여 인증을 수행하는 경우, 그로 인해 발생하는 불이익 기타 손해에 대하여 회사의 귀책사유가 없는 한 회사는 책임지지 않습니다.<br /><br />

제6조 (이용 계약의 성립)<br /><br />
① 이용계약은 회원이 되고자 하는 자(이하 “가입신청자”라 함)가 본 약관의 내용에 대하여 동의를 한 후 회원가입 신청 양식에 따라 필요한 항목을 기입•제출하는 방법으로 회원가입 신청을 하고, 회사가 위 신청에 대하여 승낙함으로써 체결됩니다.<br />

② 14세 미만 아동의 가입 신청은 거절되며, 회원가입 이후 14세 미만임이 확인될 경우에는 제7조에 따라 서비스 이용이 제한 됩니다.<br /><br />

제7조 (이용신청에 대한 승낙 유보 및 서비스 이용의 제한)<br /><br />
① 제5조에 의한 가입신청자의 신청에 대하여, 회사는 원칙적으로 서비스의 이용을 승낙합니다. 단, 회사는 다음 각 호에 해당하는 신청에 대하여는 그 사유가 해소될 때까지 승낙을 유보하거나, 승낙을 거부할 수 있습니다.<br />

1. 다른 사람의 명의를 사용하거나 이동전화 명의자의 허락 없이 SMS 인증, 범용공인인증 또는 신용카드인증을 수행하는 등 이용자 등록 시 허위로 신청하는 경우<br />

2. 회사에 의하여 이용계약이 해지된 날로부터 2개월 이내에 재이용신청을 하는 경우<br />

3. 기술상 서비스 제공이 불가능한 경우<br />

4. 고객 등록 사항을 누락하거나 오기하여 신청하는 경우<br />

5. E-mail 승인 또는 SMS 인증 등 회사가 정한 인증절차를 완료하지 않은 경우<br />

6. 만 14세 미만 아동이 서비스 이용 신청을 한 경우<br />

7. 가입신청자가 회원 자격을 상실한 사실이 있는 경우, 단, 회원 자격을 상실한 날로부터 1년이 경과한 자로서 회사의 재가입 승낙을 얻은 경우에는 그러하지 아니합니다.<br />

8. 회사로부터 회원자격정지 조치 등을 받은 회원이 그 조치기간 중에 이용계약을 임의 해지하고 재이용신청을 하는 경우<br />

9. 사회의 안녕질서 또는 미풍양속을 저해하거나, 저해할 목적으로 신청한 경우<br />

10. 기타 회사가 정한 이용신청 요건이 만족되지 않았거나 위법 또는 부당한 이용신청임이 확인된 경우 또는 회원의 책임 있는 사유로 인하여 회사가 승낙할 수 없는 경우<br />

② 제1항에 따라 회사가 회원가입 신청의 승낙을 유보하거나 거절한 경우, 회사는 이용신청자에게 승낙 유보의 사유, 승낙 가능시기 또는 승낙에 필요한 추가요청정보 내지 자료 등 기타 승낙 유보, 거절과 관련된 사항을 해당 서비스화면에 게시하거나 E-mail 등을 통하여 통지합니다.<br />

③ 회사는 서비스의 품질 향상 기타 필요한 경우, 회원을 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 기타 필요한 사항을 세분하여 그 이용에 차등을 둘 수 있습니다.<br />

④ 회사는 회원에 대하여 영화 및 비디오물의 진흥에 관한 법률, 청소년보호법 기타 관련법령에 따른 등급 및 연령 준수를 위하여 이용제한이나 등급별 제한 기타 필요한 조치를 취할 수 있습니다.<br />

⑤ 회원이 본 약관에 동의함은 서비스와 관련하여 회사에서 제공하거나 제공할 서비스에 동의하는 것으로 봅니다.<br /><br />

제8조 (회원의 의무)<br /><br />
① 회원은 서비스를 이용할 때 다음 각 호의 행위를 하여서는 아니 됩니다.<br />

1. 이용 신청 또는 변경 시 허위 사실을 기재하거나, 다른 회원의 ID 및 PASSWORD를 도용, 부정하게 사용하거나, 이동전화 명의자의 허락 없이 실사용자가 “SMS 인증”, 범용공인인증 또는 신용카드인증 등을 수행하는 행위<br />

2. 회사의 서비스 정보를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위<br />

3. 타인의 명예를 손상시키거나 불이익을 주는 행위<br />

4. 게시판 등에 음란물을 게재하거나 음란사이트를 연결(링크)하는 행위<br />

5. 회사 또는 제3자의 저작권 등 기타 권리를 침해하는 행위<br />

6. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성 등을 타인에게 유포하는 행위<br />

7. 서비스와 관련된 설비의 오 동작이나 정보 등의 파괴 및 혼란을 유발시키는 컴퓨터 바이러스 감염 자료를 등록 또는 유포하는 행위<br />

8. 서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보 및 수신자의 명시적인 수신거부의사에 반하여 광고성 정보 또는 스팸메일(Spam Mail)을 전송하는 행위<br />

9. 타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시하는 행위<br />

10. 다른 회원의 개인정보를 수집, 저장, 공개하는 행위<br />

11. 자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가할 목적으로 허위의 정보를 유통시키는 행위<br />

12. 재물을 걸고 도박하거나 사행행위를 하는 행위<br />

13. 윤락행위를 알선하거나 음행을 매개하는 내용의 정보를 유통시키는 행위<br />

14. 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상 또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의 일상적 생활을 방해하는 행위<br />

15. 서비스에 게시된 정보를 변경하는 행위<br />

16. 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 포함)의 전송 또는 게시 행위<br />

17. 회사의 직원이나 운영자를 가장하거나 사칭하여 또는 타인의 명의를 도용하여 글을 게시하거나 메일을 발송하는 행위<br />

18. 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 E-mail으로 발송하는 행위<br />

19. 스토킹(stalking) 등 다른 회원을 괴롭히는 행위<br />

20. 이용의사 없이 반복적인 호출 또는 예약 및 취소 등을 통해 회사의 서비스 제공을 방해하는 행위<br />

21. 고의적으로 결제 미수를 발생시키거나 미수가 장기간 발생되어 정상적인 서비스 이용으로 보기 어려운 행위<br />

22. 기타 불법적이거나 부당한 행위<br />

② 회원은 관계 법령, 본 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 합니다.<br />

③ 회원은 회사에서 공식적으로 인정한 경우를 제외하고는 서비스를 이용하여 상품을 판매하는 영업 활동을 할 수 없으며 특히 해킹, 광고를 통한 수익, 음란사이트를 통한 상업행위, 상용소프트웨어 불법배포 등을 할 수 없습니다. 이를 위반하여 발생한 영업 활동의 결과 및 손실, 관계기관에 의한 구속 등 법적 조치 등은 회사와는 무관하며, 회원은 이와 같은 행위와 관련하여 회사에 대하여 손해배상 의무를 집니다.<br />

④ 회원이 제1항에 명시된 행위를 한 경우에 회사는 부가적으로 제공한 혜택의 일부 또는 전부의 회수, 특정 서비스의 이용제한, 이용계약의 해지할 수 있으며 회사에 손해가 발생한 경우에는 손해배상의 청구 등의 조치를 할 수 있습니다.<br />

⑤ 회사가 제4항에 정한 조치를 할 경우 회사는 사전에 회원에게 서비스 어플리케이션∙사이트내 게재 또는 유선전화∙E-mail, SMS, App push 등으로 통보하며, 회원의 연락이 두절되거나 긴급을 요하는 것과 같이 부득이한 경우, 선 조치 후 사후 통보할 수 있습니다.<br />

⑥ 회원은 제4항에 의한 회사의 조치에 대하여 항변의 사유가 있는 경우 이에 대하여 항변을 할 수 있습니다.<br />

⑦ 제4항에 의하여 회사가 회원과의 이용계약을 해지하더라도, 해지 이전에 이미 체결된 계약의 완결에 관해서는 본 약관이 그대로 적용됩니다.<br />

⑧ 제4항에서 정한 바에 따라 이용계약이 종료될 시에는 회사는 별도 통지 없이 해당 회원과 관련된 거래를 취소할 수 있고, 구매회원이 상품의 결제를 신용카드로 결제한 경우에는 그 신용카드매출을 취소할 수 있습니다.<br />

⑨ 제4항에서 정한 바에 따라 이용계약이 종료되는 경우 회원의 재이용신청에 대하여 회사는 그 승낙을 거절할 수 있습니다.<br />

⑩ 회원은 서비스 이용을 위해 등록할 경우 현재의 사실과 일치하는 완전한 정보(이하 "등록정보")를 제공하여야 합니다.<br />

⑪ 회원은 등록정보에 변경사항이 발생할 경우 즉시 갱신하여야 원활한 서비스를 제공받으실 수 있습니다.<br /><br />

제9조 (회원에 대한 통지)<br /><br />
회원에 대한 통지를 하는 경우 회사는 서비스 애플리케이션 또는 사이트 내에 게재하거나 회원이 등록한 E-mail 주소 또는 SMS, App push 등으로 할 수 있습니다. 다만, 회사는 불특정 다수 회원에 대한 통지의 경우 서비스 게시판, 사이트 게시 등의 방법을 활용할 수 있습니다.<br /><br />

제10조 (회원 ID와 PASSWORD 관리에 대한 의무와 책임)<br /><br />
① 회사는 회원의 특정 서비스 신청 시 이용요금을 부과할 수 있으므로, 회원은 회원 ID 및 PASSWORD 관리를 철저히 하여야 합니다. 회원 ID와 PASSWORD의 관리 소홀, 부정 사용에 의하여 발생하는 모든 결과에 대하여 귀책사유가 없는 한 회사는 책임을 부담하지 않습니다.<br />

② 회원은 본인의 ID 및 PASSWORD를 제 3 자에게 이용하게 해서는 안되며, 회원 본인의 ID 및 PASSWORD를 도난 당하거나 제 3 자가 사용하고 있음을 인지하는 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우 그에 따라야 합니다.<br />

③ 회원이 스스로 등록한 ID를 변경하고자 하는 때에는 회사의 승인을 득하여야 합니다.<br /><br />

제11조 (개인정보 등의 변경, 보호)<br /><br />
① 회원은 이용신청 시 기재한 사항이 변경되었을 경우에는 즉시 변경사항을 최신의 정보로 수정하여야 합니다. 단, 이름, 회원 ID 등은 회사의 승인을 받아 수정할 수 있습니다.<br />

② 수정하지 않은 정보로 인하여 발생하는 손해는 당해 회원이 부담하며, 회사는 이에 대하여 귀책사유가 없는 한 책임을 지지 않습니다.<br />

③ 회사는 회원의 정보를 서비스를 제공하기 위한 목적 이외의 용도로 사용하거나 회원의 동의 없이 제3자에게 제공하지 않습니다. 단, 다음의 경우는 예외로 합니다.<br />

1. 서비스 제공에 관한 계약을 이행하기 위한 것으로 판매자에게 거래 내역, 정산 내역 제공 등에 필요한 최소한의 회원정보(성명, 연락처 등)를 제공하는 경우<br />

2. 법령에서 회원의 개인정보의 이용과 제3자에 대한 정보제공을 허용하고 있는 경우<br />

④ 회사는 관련법령이 정하는 바에 따라서 회원 등록정보를 포함한 회원의 개인정보 등을 보호하기 위하여 노력합니다. 회원의 개인정보 등의 보호에 관해서는 관련 법령 및 회사가 정하는 개인정보처리방침에 정한 바에 의합니다.<br />

⑤ 회사는 수집된 개인정보 등의 취급 및 관리 등의 업무를 스스로 수행함을 원칙으로 하나, 필요한 경우 회원의 동의를 받거나 통지를 한 후 위 업무의 일부 또는 전부를 회사가 선정한 회사에 위탁할 수 있습니다.<br /><br />

제10조 (계약해지 및 이용제한)<br /><br />
① 회원은 다음 각 호에서 정한 바에 따라 이용계약을 해지할 수 있습니다.<br />

1. 회원은 언제든지 회사에 이용계약 해지의 의사를 통지함으로써 이용계약을 해지할 수 있습니다. 단, 해지의사를 통지하기 전에 현재 진행 중인 모든 상품의 거래를 완료하거나 철회 또는 취소하여야 하며, 회사는 귀책사유가 없는 한 해당 상품거래에 관하여 책임을 부담하지 않습니다.<br />

2. 회원탈퇴로 인해 발생할 수 있는 사항에 대하여 회사는 귀책사유가 없는 한 책임을 부담하지 아니하며, 이용계약이 종료되면 회사가 이용계약에 기초하여 회원에게 부가적으로 제공한 혜택이 함께 종료됩니다.<br />

② 회사는 회원이 제20조에 규정한 회원의 의무를 이행하지 않을 경우, 사전 통지 후 이용계약을 해지하거나 또는 서비스 이용을 중단 조치를 취할 수 있습니다. 다만 긴급히 조치할 필요가 있는 경우에는 사후에 통지할 수 있습니다.<br />

③ 회사는 회원이 이용계약을 체결하여 ID와 PASSWORD를 부여 받은 후에라도 회원의 자격에 제한이 있는 때에는 서비스 이용을 제한할 수 있습니다.<br />

④ 회사는 회원 가입 후 3개월 동안 서비스 사용 이력이 없는 회원에 대하여는, 일정 기간을 정하여 사용의사를 묻고 고지한 바에 따라 계약을 종료할 수 있습니다.<br />

⑤ 제2항 내지 제4항의 회사 조치에 대하여 회원은 회사가 정한 절차에 따라 이의신청을 할 수 있습니다.<br />

⑥ 제5항의 이의가 정당하다고 회사가 인정하는 경우, 회사는 즉시 서비스의 이용을 재개합니다.<br /><br />

제12조 (양도 금지)<br /><br />
① 회원은 서비스의 이용권한, 기타 이용 계약상 지위를 타인에게 양도, 증여, 담보 제공할 수 없습니다.<br /><br />

제13조 (손해배상)<br /><br />
① 회원이 본 약관의 규정을 위반함으로 인하여 회사에 손해가 발생하게 되는 경우, 본 약관을 위반한 회원은 회사에 발생하는 손해를 배상하여야 합니다.<br />

② 회원이 서비스를 이용함에 있어 행한 불법행위나 본 약관 위반행위로 인하여 회사가 당해 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 당해 회원은 자신의 책임과 비용으로 회사를 면책시켜야 하며, 당해 회원은 그로 인하여 회사에 발생한 손해를 배상하여야 합니다.<br />

③ 회사의 고의나 과실에 의하여 회원에게 손해가 발생한 경우 그러한 손해에 대하여는 회사에서 책임을 부담하여야 합니다.<br /><br />

제14조 (면책사항)<br /><br />
① 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 회사의 귀책사유가 없습니다.<br />

② 회사는 회원의 귀책사유로 인한 서비스의 이용장애에 대하여 책임을 지지 않습니다.<br />

③ 회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여는 무관하며 서비스를 통하여 얻은 2차적인 자료로 인한 손해 등에 대하여도 책임을 지지 않습니다. 회사는 회원이 사이트에 게재한 정보, 자료, 사실의 신뢰도 및 정확성 등 내용과는 무관합니다.<br />

④ 회사는 회원의 서비스 이용 과정에서 발생한 회원 상호간 또는 회원과 제3자 상호간에 발생한 분쟁(서비스 이용 중에 발생한 사고, 서비스와 무관하게 발생한 범죄행위 등을 포함하나 이에 한정하지 않음)에 대해서는 개입하지 않으며 책임을 부담하지 않습니다.<br />

⑤ 회원이 자신의 개인정보를 타인에게 유출 또는 제공함으로써, 발생하는 피해에 대해서 회사는 귀책사유가 없는 한 책임을 지지 않습니다.<br />

⑥ 상품 또는 정보 등을 통해 표현하거나 드러나는 회원의 견해와 회사의 견해는 무관하며, 회사는 회원이 제공하는 상품 또는 정보 등에 대하여 귀책사유가 없는 한 책임을 부담하지 아니합니다.<br />

⑦ 서비스 화면에서 링크, 배너 등을 통하여 연결된 회사(이하 피연결회사)와 회원간에 이루어진 거래에 회사는 무관합니다.<br />

⑧ 회사는 서비스의 내용 및 서비스에서 제공되는 정보의 정확성을 보증하지 않습니다.<br />

⑩ 회사가 제공하는 중개 서비스에 관하여, 회사는 서비스를 이용하는 회원과 서비스 제공자 간의 거래를 중개하는 시스템을 운영•관리•제공할 뿐, 회원을 포함한 거래당사자(제휴사, 운송제공자 등 포함)들을 대리하지는 않습니다. 거래당사자 간 성립된 거래와 관련한 정보, 서비스, 운임 및 이용료 등에 대한 책임은 각 거래당사자가 직접 부담합니다.<br />

⑪ 회사가 제공하는 중개 서비스에 관하여, 회사는 회원과 서비스 제공자 간의 거래와 관련하여 서비스 신청의사 또는 수락의사의 존부 및 진정성, 거래 대상의 품질, 완전성, 안전성, 적법성 및 타인의 권리에 대한 비침해성, 회원 또는 서비스 제공자가 제공한 정보 및 그 정보의 진실성 또는 적법성 등 일체에 대하여 보증하지 않고, 그와 관련하여 어떠한 책임도 부담하지 않습니다.<br /><br />

제15조 (회사의 연락처)<br /><br />
회사의 상호, 주소, 전화 번호 그 밖의 연락처는 다음과 같습니다.<br /><br />

① 상호 : 주식회사 디인사이트<br />

② 주소 : 서울특별시 강남구 선릉로 86길 38, 7층 7345호(대치동)<br /><br />

제16조 (분쟁의 해결 및 관할법원)<br /><br />
① 서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우, 회사와 회원은 분쟁의 해결을 위해 성실히 협의합니다.<br />

② 제1항의 협의에서도 분쟁이 해결되지 않을 경우 양 당사자는 전기통신사업법 제 45조(방송통신위원회의 재정), 개인정보보호법 제43조(조정의 신청 등)의 규정에 의하여 방송통신위원회 또는 개인정보분쟁조정위원회에 분쟁조정을 신청할 수 있습니다.<br />

③ 제2항에 의하여서도 분쟁이 해결되지 않을 경우 양 당사자는 민사소송법상의 관할법원에 소를 제기할 수 있습니다.<br /><br />

[부칙]<br />
(시행일) 이 약관은 2025년 07월 17일 부터 시행합니다.`,
    `【Pulseonship 개인정보처리방침】<br /><br />

주식회사 디인사이트(이하 "회사")는 Pulseonship 서비스를 제공함에 있어 정보통신망법, 개인정보 보호법 등 관련 법령을 준수하며, 회원의 개인정보를 안전하게 보호하고 적법하게 처리하기 위하여 아래와 같이 개인정보처리방침을 수립·공개합니다.<br /><br />

─────────────────────────────<br /><br />

■ 개인정보 수집 항목 및 수집 방법<br /><br />
회사는 회원가입, 본인확인, 계약이행, 고객상담 등 서비스 제공을 위하여 최소한의 개인정보를 수집합니다.<br />
필수 수집 항목: 이름, 연락처, 이메일, ID, 비밀번호, 회사명, 사업자등록번호, 화물 정보, 출발지/도착지, 결제 정보 등<br />
선택 수집 항목: 추가 연락처, 부가 서비스 요청 정보, 마케팅 수신 동의 여부 등<br />
수집 방법: 홈페이지, 모바일 앱, 서면 양식, 이메일, 고객센터, 이벤트 응모 등<br /><br />

─────────────────────────────<br /><br />

■ 개인정보의 이용 목적<br /><br />
회원가입 및 본인 확인, 계약 체결 및 이행<br />
화물 운송 및 배차, 통관, 보험 처리 등 물류 서비스 제공<br />
서비스 개선, 고객 문의 및 민원 처리, 분쟁 해결<br />
정산, 청구 및 결제 처리, 세금계산서 발행<br />
서비스 고도화 및 맞춤형 서비스 제공<br /><br />

─────────────────────────────<br /><br />

■ 개인정보의 보유 및 이용 기간<br /><br />
회원 탈퇴 시 또는 동의 철회 시까지 보관하며, 상법, 전자상거래법 등 관계법령에 따라 일정 기간 보관될 수 있습니다.<br />
예: 계약 또는 청약철회 등 거래기록 5년, 대금결제 및 재화 등의 공급기록 5년, 소비자 불만 또는 분쟁처리 기록 3년 등<br /><br />

─────────────────────────────<br /><br />

■ 개인정보의 제3자 제공<br /><br />
회사는 서비스 제공 및 계약 이행을 위해 필요한 범위 내에서 회원의 개인정보를 국내외 운송사, 통관사, 보험사, PG사, 관세사, 창고 운영사 등에게 제공합니다.<br />
제공 목적, 항목, 기간 등은 별도의 제3자 제공 동의서에 따라 관리됩니다.<br /><br />

─────────────────────────────<br /><br />

■ 개인정보의 처리 위탁<br /><br />
회사는 원활한 서비스 제공을 위해 일부 업무를 외부 전문업체에 위탁할 수 있으며, 위탁업체와 위탁업무 내용은 홈페이지를 통해 별도로 고지합니다.<br /><br />

─────────────────────────────<br /><br />

■ 개인정보 파기 절차 및 방법<br /><br />
개인정보는 수집 및 이용 목적이 달성된 후 내부 방침 및 관련 법령에 따라 안전하게 파기됩니다.<br />
전자적 파일 형태는 복구 불가능한 기술적 방법으로 삭제하며, 종이 문서는 분쇄 또는 소각하여 파기합니다.<br /><br />

─────────────────────────────<br /><br />

■ 회원 및 법정대리인의 권리와 행사 방법<br /><br />
회원은 언제든지 개인정보 열람, 정정, 삭제, 처리정지를 요청할 수 있으며, 회사는 지체 없이 필요한 조치를 합니다.<br />
권리 행사는 고객센터 또는 서면, 전화, 이메일 등을 통해 가능합니다.<br /><br />

─────────────────────────────<br /><br />

■ 개인정보 보호책임자<br /><br />

이름: 개인정보 보호책임자<br />
연락처: d.lee@theinsight.co.kr<br /><br />

─────────────────────────────<br /><br />

■ 개인정보처리방침의 변경<br /><br />

본 방침은 관계 법령, 회사 정책에 따라 변경될 수 있으며, 변경 시 사전 고지 후 시행합니다.<br />
공고일 및 시행일: 별도 고지<br /><br />

─────────────────────────────<br /><br />

Pulseonship은 회원의 개인정보를 소중히 관리하고, 안전한 물류 서비스를 위해 최선을 다하겠습니다.`
]

export { termsContent }